// resolve-app resolves by domain, except when the first path segment is /sv or /en —
// that is how www.wallmek.se serves app 1 on /sv and app 3 on /en. The full href is passed
// through, so no origin allow-list is needed here; this helper only strips the prefix from
// CMS links. Do not drop the path from the resolve-app URL: it would collapse SE /en into app 1.
export const checkForLocalePrefix = (path: string) => {
    const hasENPrefix = !!(path?.toLowerCase() === "/en" || path?.toLowerCase().startsWith("/en/"));

    if (hasENPrefix) {
        return "en";
    }

    return "sv";
};

export const startsWithLocalePrefix = (url: string) => {
    const path = url.includes("http") ? url.split("//")[1].split("/")[1] : url;

    const hasENPrefix = !!(
        path?.toLowerCase() === "en" ||
        path?.toLowerCase().startsWith("en/") ||
        path?.toLowerCase().startsWith("/en")
    );
    const hasSVPrefix = !!(
        path?.toLowerCase() === "sv" ||
        path?.toLowerCase().startsWith("sv/") ||
        path?.toLowerCase().startsWith("/sv")
    );

    return hasENPrefix || hasSVPrefix ? true : false;
};
